/* @flow */
import { mutateAsync, requestAsync } from 'redux-query';

import * as q from './queries';

export function registerUser(phoneNumber: string, queryString: string, silent: boolean) {
  return mutateAsync(q.registerUser(phoneNumber, queryString, silent));
}

export function fetchUser(userId: string) {
  return requestAsync(q.fetchUser(userId));
}

export function authenticateUser(phoneNumber: string, otpCode: string) {
  return mutateAsync(q.authenticateUser(phoneNumber, otpCode));
}

export function unauthenticateUser(userId: string, accessToken: string) {
  return mutateAsync(q.unauthenticateUser(userId, accessToken));
}

export function updateUser(userId: string, updates: Object) {
  return mutateAsync(q.updateUser(userId, updates));
}

export function updateUserProfile(userId: string, updates: Object) {
  return mutateAsync(q.updateUserProfile(userId, updates));
}



// WEBPACK FOOTER //
// ./src/redux/users/actions.js